import { useContext } from 'react'
import { FronthubContext } from 'front-hub-context-api'
import publicPath from '../../../common/microfrontend/public-path'
import { CONTEXT } from '../../../constants'

export default function usePath() {
  const {
    [CONTEXT]: { configuration },
  } = useContext(FronthubContext)
  return o => (configuration.repository ? publicPath(configuration) + o : o)
}
